<div
    *ngIf="mentions?.length; else emptyContainer"
    class="agpr-topMentionsChart-mentions"
>
    @for (mention of mentions; track mention) {
        <agpr-top-mentions-chart-card
            [mention]="mention"
            [metadata]="metadata"
            [mentionCustomization]="_displayElement.topMentionsMetadata"
            [metadata1Color]="_displayElement.styles.colorMap.metadata1"
            [metadata2Color]="_displayElement.styles.colorMap.metadata2"
            [outletPhoto]="outletPhotoMap?.get(mention.publication.uuid)"
        ></agpr-top-mentions-chart-card>
    }
</div>

<ng-template #emptyContainer>
    <div
        class="agpr-topMentionsChart-mentions"
    >
        <agpr-message
            [severity]="messageSeverities.noContent"
            [style]="agprComponentStyle.social"
        >
            {{ 'Common.noContentToDisplay' | localize }}
        </agpr-message>
    </div>
</ng-template>
